<template>
	<div class="detail-page">
		<div class="detail-page__header">
			<h2 class="detail-page__header-title">
				{{ businessDetail.title }}
			</h2>
			<p class="detail-page__header-time">
				发布时间：{{ businessDetail.publishtime | formatDate }}
			</p>
		</div>
		<div class="detail-page__content" v-html="businessDetail.content"></div>
		<div class="detail-page__footer">
			<div>
				<span>上一篇：</span
				><router-link
					:to="{ path: turnPageUrl + businessDetail.prevId }"
					v-if="businessDetail.prevId"
					>{{ businessDetail.prevTitle }}</router-link
				>
				{{ businessDetail.prevId ? '' : '无' }}
			</div>
			<div>
				<span>下一篇：</span
				><router-link
					:to="{ path: turnPageUrl + businessDetail.nextId }"
					v-if="businessDetail.nextId"
					>{{ businessDetail.nextTitle }}</router-link
				>
				{{ businessDetail.nextId ? '' : '无' }}
			</div>
		</div>
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
	props: {},
	data() {
		return {}
	},
	computed: {
		...mapState('XMZS', ['businessDetail']),
		// 翻页
		turnPageUrl() {
			const orgPath = this.$route.fullPath
			const len = orgPath.lastIndexOf('/') + 1
			return orgPath.substr(0, len)
		},
	},
	created() {
		this.fetchBusinessDetail({ id: this.$route.params.id })
	},
	mounted() {},
	watch: {},
	methods: {
		...mapActions('XMZS', ['fetchBusinessDetail']),
	},
	components: {},
}
</script>

<style lang="scss"></style>
